export function toTitleCaseAndDash(value: string): string {
  return value
    ?.split('_')
    .map((value) => value.charAt(0).toUpperCase() + value.slice(1))
    .join('-');
}
